import { MouseEvent } from "react";
import { MenuItem } from "@remo-co/ui-core/src/components/MenuItem";
import { Link } from "react-router-dom";
import { ArrowCircleBrokenRight as ArrowCircleBrokenRightIcon } from "@remo-co/ui-core/src/icons/ArrowCircleBrokenRight";
import { useI18n } from "i18n";

interface Props {
  code?: string;
  goToEvent: (e: MouseEvent<HTMLAnchorElement>) => void;
  disabled?: boolean;
  className?: string;
}

const EnterEventButton = ({
  code,
  goToEvent,
  disabled,
  className,
}: Props): JSX.Element => {
  const { t } = useI18n(["common", "event", "manageEvent"]);
  return (
    <li>
      <MenuItem
        component={Link}
        to={`/e/${code}`}
        // @ts-expect-error MUI uses a trick to merge Link and MenuItem types, but we shouldn't
        onClick={goToEvent}
        disabled={disabled}
        className={className}
      >
        <ArrowCircleBrokenRightIcon />
        {t("event:enter.event")}
      </MenuItem>
    </li>
  );
};
export default EnterEventButton;
